import { useContext } from 'react';

import { AuthContext } from './AuthContext';

export const useAuthContext = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('AuthContext must be used within an AuthContextProvider');
  }

  return context;
};
